import { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setloggedInuser] = useState(null);

  // Initial check on app load / refresh
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/auth/me`, {
          withCredentials: true,
        });
        setloggedInuser(data.user);
        setIsAuthenticated(true);
      } catch (error) {
        setloggedInuser(null);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };
    checkAuth();
  }, []);

  // Cross-tab logout sync — instant, via storage event
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "logout-event") {
        setloggedInuser(null);
        setIsAuthenticated(false);
        navigate("/login");
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [navigate]);

  // Safety net — re-check session validity when tab regains focus
  useEffect(() => {
    const handleFocus = async () => {
      // Agar already loading ya logged out hai to dobara check karne ki zaroorat nahi
      if (isLoading || !isAuthenticated) return;

      try {
        await axios.get(`${process.env.REACT_APP_API_URL}/auth/me`, {
          withCredentials: true,
        });
        // valid hai, kuch karne ki zaroorat nahi
      } catch (error) {
        setloggedInuser(null);
        setIsAuthenticated(false);
        navigate("/login");
      }
    };

    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [isLoading, isAuthenticated, navigate]);

  const login = (user) => {
    setloggedInuser(user);
    setIsAuthenticated(true);
  };

  const logout = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/logout`,
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.error("Logout error:", error.message);
    }

    localStorage.setItem("logout-event", Date.now()); // doosre tabs ko signal
    setloggedInuser(null);
    setIsAuthenticated(false);
    navigate("/login");
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isLoading,
        login,
        logout,
        user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);